import React from "react";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 px-4 py-5 text-center sm:px-6">
      <p className="mx-auto max-w-2xl text-xs leading-relaxed text-slate-500 sm:text-sm">
        &copy; {year} Engineering of Stocks. All rights reserved.
        <br className="sm:hidden" />
        <span className="hidden sm:inline"> </span>
        Maintained &amp; developed by Vikas Yadav.
      </p>
    </footer>
  );
};

export default Footer;
